import { findMany, find, hasClass, removeClass, on } from '../helpers';

// Define a function to handle the "Show More" functionality for a given container.
const handleShowMore = container => {
    // Check if the container has already been processed.
    if (container.bound) {
        return;
    }

    // Mark the container as processed to prevent duplicate processing.
    container.bound = true;

    // Find the button and body copy elements within the container.
    const button = find('[data-show-button]', container);
    const content = find('[data-show-content]', container);

    // Define a function to open the content when the button is clicked.
    const showMore = () => {
        // Iterate through each child element of the content.
        Array.from(content.children).forEach(child => {
            // If the child has the 'hidden' class, remove it along with 'opacity-0'.
            if (hasClass(child, 'hidden')) {
                removeClass(child, ['hidden', 'opacity-0']);
            }
        });

        // Remove the button after opening the content.
        button.remove();
    };

    // Add a click event listener to the button to trigger the showMore function.
    on('click', showMore, button);
};

// Find all elements with the 'data-show-more' attribute and apply the handleShowMore function to each.
findMany('[data-show-more]').forEach(handleShowMore);
